import axios from "axios";
import environment from "@/environment";

const api = axios.create({ baseURL: `${environment.API}/`});

export class RequestInterceptor {
	addAuthorizationHeader (config) {
		const storage = JSON.parse(localStorage.getItem("params") || "{}");
		config.headers.Authorization = "Bearer " + (storage.token || "");
		return config;
	}
}


export class TurnosService {
axios = api;

constructor () {
	const interceptor = new RequestInterceptor();
	this.axios.interceptors.request.use(interceptor.addAuthorizationHeader);
}

async listTurnos () {
	const response = await this.axios.get("shifts/");
	return response.data;
}

async obterTurnoAtual () {
	const response = await this.axios.get("shifts/currentShift");
	return response.data;
}
}
